import { render, staticRenderFns } from "./DesvincularColaboradoresModal.vue?vue&type=template&id=374fe920&scoped=true&"
import script from "./DesvincularColaboradoresModal.vue?vue&type=script&lang=ts&"
export * from "./DesvincularColaboradoresModal.vue?vue&type=script&lang=ts&"
import style0 from "./DesvincularColaboradoresModal.vue?vue&type=style&index=0&id=374fe920&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374fe920",
  null
  
)

export default component.exports